import { Address } from './address.model';

export class UserInfo {
  id: string;
  firstName: string;
  lastName: string;
  companyName: string;
  address: Address;
  addressLine1: string;
  addressLine2: string;
  taxNumber: string;
  phoneNumber: string;
  email: string;
  city: string;
  stateProvince: string;
  country: string;
  postalCode: number;
  currency: string;

  constructor(
    id?: string,
    firstName?: string,
    lastName?: string,
    companyName?: string,
    address?: Address,
    addressLine1?: string,
    addressLine2?: string,
    taxNumber?: string,
    phoneNumber?: string,
    email?: string,
    city?: string,
    stateProvince?: string,
    postalCode?: number,
    country?: string,
    currency?: string
  ) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.companyName = companyName;
    this.address = address;
    addressLine1 = addressLine1;
    addressLine2 = addressLine2;
    this.taxNumber = taxNumber;
    this.phoneNumber = phoneNumber;
    this.email = email;
    this.city = city;
    this.stateProvince = stateProvince;
    this.postalCode = postalCode;
    this.country = country;
    this.currency = currency;
  }
}
